export const areas = [
  { nameEn: 'Muscat', nameAr: 'مسقط' },
  { nameEn: 'Seeb', nameAr: 'السيب' },
  { nameEn: 'Al Khuwair', nameAr: 'الخوير' },
  { nameEn: 'Azaiba', nameAr: 'العذيبة' },
  { nameEn: 'Mabela', nameAr: 'المعبيلة' },
  { nameEn: 'Mawaleh', nameAr: 'الموالح' },
  { nameEn: 'Barka', nameAr: 'بركاء' },
  { nameEn: 'Sohar', nameAr: 'صحار' },
  { nameEn: 'Rustaq', nameAr: 'الرستاق' },
  { nameEn: 'Nakhal', nameAr: 'نخل' },
  { nameEn: 'Quriyat', nameAr: 'قريات' },
  { nameEn: 'Nizwa', nameAr: 'نزوى' }
];